import {
  
  get,
  post,
  put
 
} from "services/BaseClient/Client";
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";
import { CreateUrlFilter } from "helpers/CreateURLFilter";


export const getInviteListFilter = async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
  const url = `${endpoints.getInviteListFilter}?${query||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const acceptInviteStatus = async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.acceptInvite}/${data.id}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
};
export const rejectInviteStatus = async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.rejectInvite}/${data.id}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
};
